import { render, staticRenderFns } from "./HogeZeevaartschool.vue?vue&type=template&id=1f047bd4&"
import script from "./HogeZeevaartschool.vue?vue&type=script&lang=ts&"
export * from "./HogeZeevaartschool.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports